export const GRAPH_TYPE = {
  DELAY: 'ARR_DELAY_BIN',
  DELAY_RATIO: 'DELAY_RATIO_BIN'
};

export const AIRPORT_TYPE = {
  ORIGIN: {
    from: 'ORIGIN',
    to: 'DEST'
  },
  DEST: {
    from: 'DEST',
    to: 'ORIGIN'
  }
};



// WEBPACK FOOTER //
// ./client/app/services/airport/airport.constants.js